/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './MenuItemDivider';

const MenuItemDividerManager: ComponentManagerFn<'MenuItemDivider'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'MenuItemDivider'>(platform, 'MenuItemDivider'),
    type: 'MenuItemDivider',
    name: 'Menu Item Divider',
    defaultValue,
    props: {},
    category: 'Toolbar',
    getDisplayText: () => '',
    noOverlay: true,
    icon: { iconName: 'grip-lines' },
    description: `**Overview**<br/>
The Menu Item Divider is a purely visual component used within a Menu to create separation between groups of items. It renders as a thin horizontal line.
Use this component to organize long menus into logical sections, improving readability and usability (e.g., separating primary actions from destructive ones).

**1. Configuration**<br/>
* **Zero Configuration:** This component requires no properties (props: {}). It simply draws a standard separator line according to the system theme.

**2. Best Use Cases**<br/>
* **Grouping:** Separating "Edit" and "View" actions from "Export" actions.
* **Destructive Actions:** Placing a divider before a "Delete" option to visually set it apart to prevent accidental clicks.
* **Context Sections:** Separating "Account Settings" from "Application Settings" in a user menu.`,
  };
};

export default MenuItemDividerManager;
